const BASE_URL = import.meta.env.VITE_API_BASE_URL

if (!BASE_URL) {
  console.error('VITE_API_BASE_URL is not defined in environment')
}

export const endpoints = {
  // Auth endpoints
  login: {
    url: `${BASE_URL}/login`,
    method: 'POST',
  },
  logout: {
    url: `${BASE_URL}/logout`,
    method: 'GET',
  },
  getUserData: {
    url: `${BASE_URL}/info/fetch_data`,
    method: 'GET',
  },

  // Game-related endpoints
  getGameIdea: {
    url: `${BASE_URL}/prompt/description`,
    method: 'POST',
  },
  userLeaderBoard: {
    url: `${BASE_URL}/user-leaderboard/`,
    method: 'GET',
  },
  deleteGame: {
    url: `${BASE_URL}/game/delete`,
    method: 'PUT',
  },
  createGame: (promptID: string) => ({
    url: `${BASE_URL}/game/generate_game?prompt_id=${promptID}`,
    method: 'POST',
  }),
  getGames: () => ({
    url: `${BASE_URL}/history/games`,
    method: 'GET',
  }),
  getGame: (gameId: string) => ({
    url: `${BASE_URL}/game/game_data?game_id=${gameId}`,
    method: 'GET',
  }),
  saveGameData: {
    url: `${BASE_URL}/game/handler`,
    method: 'POST',
  },
  publishGame: {
    url: `${BASE_URL}/game/publish`,
    method: 'PUT',
  },
  rePublishGame: {
    url: `${BASE_URL}/game/republish`,
    method: 'PUT',
  },
  gameUpdate: {
    url: `${BASE_URL}/game/update-game`,
    method: 'PATCH',
  },
  uploadProfileImage: {
    url: `${BASE_URL}/upload-profile`,
    method: 'POST',
  },
  inPainting: {
    url: `${BASE_URL}/utils/asset/iterate/INPAINT`,
    method: 'POST',
  },
  bgRemoval: {
    url: `${BASE_URL}/utils/asset/remove`,
    method: 'POST',
  },
  assetIterateScale: {
    url: `${BASE_URL}/utils/asset/iterate/v2`,
    method: 'POST',
  },

  // Others
  submitFeedback: {
    url: `${BASE_URL}/report-issue`,
    method: 'POST',
  },

  uploadAsset: {
    url: `${BASE_URL}/utils/asset/upload`,
    method: 'POST',
  },
  createAsset: {
    url: `${BASE_URL}/utils/asset/iterate`,
    method: 'POST',
  },

  // --- THIS IS THE NEW ENDPOINT  ---
  iterateRef: {
    url: `${BASE_URL}/utils/asset/iterate-ref`, 
    method: 'POST',
  },
  // -----------------------------------------------

  createAvatar: {
    url: `${BASE_URL}/utils/avatar/iterate`,
    method: 'POST',
  },
  uploadSound: {
    url: `${BASE_URL}/game/upload_sound`,
    method: 'POST',
  },
  iterate: {
    url: `${BASE_URL}/utils/iterate`,
    method: 'POST',
  },
  iterateStatus: {
    url: `${BASE_URL}/utils/iterate/status`,
    method: 'POST',
  },
  setUserOnboarded: (userId: string) => ({
    url: `${BASE_URL}/onboard/${userId}`,
    method: 'POST',
  }),
}
